import { convertBboxToWestSouthEastNorthBbox } from '../../domain/utils/map'
import { getBIParams } from '../../domain/analytics/BiTagger'
import { bboxToSearchParameter } from '../../domain/map/conversion'
import request from '../../domain/utils/request'
import { getService, getServiceParameters } from '../../parameters'
import SERVICES from '../../services.constants'

export const requestSuggest = (bbox, locale, { terms, suggestFilterType = 'all' }) => {
  const service = getService(SERVICES.SUGGEST)
  const params = {
    q: terms,
    filter: suggestFilterType,
    limit: 5,
    focus_bbox: bboxToSearchParameter(convertBboxToWestSouthEastNorthBbox(bbox)),
    ...getServiceParameters(SERVICES.SUGGEST, locale),
    ...getBIParams()
  }

  return request.get(service, { locale, params }).then(response => response)
}
